export enum Interest {
  PHOTOVOLTAIC_SYSTEM = 'PhotovoltaicSystem',
  WALLBOX = 'Wallbox',
  HEAT_PUMP = 'HeatPump',
  ENERGY_MANAGEMENT = 'EnergyManagement',
}
